import React from 'react';

// Styles
import styles from './styles/BasicHeader.scss';

const SharedFolderHeader = () => {
    return (
        <div className={`primary-viewport-width ${styles.outerContainer}`}>
            <div className={styles.innerContainer}>
                <div className={styles.content}>
                    <div className={styles.shared}>One-of-a-kind items were shared with you!</div>
                </div>
            </div>
        </div>
    );
};

export default SharedFolderHeader;
